import React from "react";
import { useAppSelector } from "../../../../../app/hooks";
import { mainColourSelector } from "../../../../chatbotSlice";
import {toRgba} from "./ImageCarouselSlideButton";

interface ImageCounterProps {
    currentIndex: number
    images: string[];
}

export const ImageCounter: React.FC<ImageCounterProps> = ({
                                                              currentIndex,
                                                              images,
                                                          }) => {
    const mainColour = useAppSelector(mainColourSelector)
    const bgColor  = toRgba(mainColour, 0.65);

    return (
        <div
            className="flex w-16 py-1 px-1.5 items-center justify-center rounded-md gap-1.5"
            style={{ background: bgColor }}
        >
            <img
                src="/camera.svg"
                alt="Camera"
                className="w-3.5 h-3.5"
            />
            <span className='text-xs font-semibold text-white'>{currentIndex + 1}/{images.length}</span>
        </div>
    );
};
